import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RetryFailedEntitiesService {

  constructor(private http: HttpClient) {}

  /**
   * Get failed entities by request
   * @param pdfEngineApiUrl - Base PDF engine API URL
   * @param taxYear - Tax year
   * @param requestId - Request ID
   */
  getFailedEntities(pdfEngineApiUrl: string, taxYear: string, requestId: string): Observable<any> {
    const url = `${pdfEngineApiUrl}/getFailedEntitiesByRequest?taxYear=${taxYear}&requestId=${requestId}`;
    
    return this.http.get<any>(url, { withCredentials: true });
  }

  /**
   * Retry bulk export for failed entities
   * @param pdfEngineApiUrl - Base PDF engine API URL
   * @param taxYear - Tax year
   * @param scenario - Scenario
   * @param parentLeId - Parent LE ID (tax payer)
   * @param requestType - Request type (mode)
   * @param format - Format
   * @param srcType - Source type (EFILE or STATE)
   * @param returnType - Return type
   * @param businessType - Business type
   * @param jcdKey - JCD Key
   * @param groupKey - Group key
   * @param requestId - Request ID
   * @param requestedBy - Requested by user
   * @param taxPayerName - Tax payer name
   * @param payload - Payload with entities and forms
   * @param formType - Form type
   */
  pdfsBulkExport(
    pdfEngineApiUrl: string,
    taxYear: string,
    scenario: string,
    parentLeId: string,
    requestType: string,
    format: string,
    srcType: string,
    returnType: string,
    businessType: string,
    jcdKey: string = '250',
    groupKey: string = '',
    requestId: string = '0',
    requestedBy: string = '0',
    taxPayerName: string = '',
    payload: any = { entities: "All", forms: "All" },
    formType: string = ''
  ): Observable<any> {
    // Build URL with query parameters
    let url = `${pdfEngineApiUrl}/pdfsBulkExport?`;
    url += `taxYear=${taxYear}`;
    url += `&scenario=${scenario}`;
    url += `&parentLeId=${parentLeId}`;
    url += `&mode=${requestType}`;
    url += `&format=${format}`;
    url += `&srcType=${srcType}`;
    url += `&returnType=${returnType}`;
    url += `&businessType=${businessType}`;
    url += `&jcdKey=${jcdKey}`;
    url += `&groupKey=${groupKey}`;
    url += `&requestId=${requestId}`;
    url += `&requestedBy=${requestedBy}`;
    url += `&taxPayerName=${taxPayerName}`;
    url += `&formType=${formType}`;

    // Set headers for JSON content
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });

    return this.http.post<any>(url, JSON.stringify(payload), { headers, withCredentials: true });
  }
}
